// extracted by mini-css-extract-plugin
export var standaloneTable = "_eb-0";
export var standaloneTableWithBodyFill = "_eb-1";
export var withExtraHeader = "_eb-2";